<h3 class="channels-invite-title" translate>CHANNELS.INVITED.TITLE</h3>
<p class="channels-invite-description" translate>CHANNELS.INVITED.CONTENT</p>
<cc-social-buttons-group
  [providers]="socialProviders"
  (providerClick)="onSocialClick($event)"
>
</cc-social-buttons-group>
<cc-channels-details button="CHANNELS.REGISTER.START" [invited]="true"></cc-channels-details>
